<div class="c-page">
    <div class="container u-pb60">
        <div class="row mobile--orange u-pt30 u-pb20">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a [routerLink]="['/']">{{'SaaDelegatePortal.home'|translate}}</a></li>
                        <li class="breadcrumb-item active" aria-current="page">&nbsp;-&nbsp; </li><span
                            class="">{{'SaaDelegatePortal.location'|translate}}</span>
                    </ol>
                </nav>
                <h2 class="o-title">{{'SaaDelegatePortal.title'|translate}}</h2>
                <p class="o-text">{{'SaaDelegatePortal.titleDescription'|translate}}</p>
            </div>
        </div>

        <section class="c-results">
                <div class="container " style="padding: 20px; margin-right: 20px; width:100%"> 
                    <form class="o-form" [formGroup]="personDelegateForm">
                    <div class="col-md-12"><strong>{{'SaaDelegatePortal.titleFormDelegate'|translate}}</strong>
                        <p>{{'SaaDelegatePortal.subtitleFormDelegate'|translate}}</p>
                    </div>
                    
                    <!-- <div class="col-md-4 u-pt20">
                        <div class="form-group">
                          <label class="o-title o-title--label o-title--required js-txt16" id="FirstName">Persona a delegar:</label>
                          <input class="o-form__input" style="background:white" type="text" formControlName="mdmid"  id="firstName" placeholder="Buscar por nombre, rut, correo">
                          <div *ngIf="personDelegateForm.controls['mdmid'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>&nbsp; Requerido</mat-error></h5></span>
                          </div>
                        </div>
                    </div> -->
                    <div class="col-md-4 u-pt20">
                      <div class="form-group">
                        <label class="o-title o-title--label o-title--required js-txt16"  id="FirstName">{{'SaaDelegatePortal.labelPersonDelegate'|translate}}: <svg matTooltip="{{'SaaDelegatePortal.tooltipSearchPeople' | translate}}"
                          width="1em" height="1em" viewBox="0 0 16 16"
                          class="bi bi-question-circle ptooltip--static ptooltip"
                          fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd"
                              d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                          <path
                              d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>&nbsp;</label> 
                        <input  class="o-form__input" (input)="searchPerson($event)" style="background-color: white;" formControlName="searchPeople" [(ngModel)]="searchPeople"   type="text" placeholder="{{'SaaDelegatePortal.placeholderPersonSearch'|translate}}" [matAutocomplete]="autoPersonBHP">
                        <mat-autocomplete #autoPersonBHP="matAutocomplete">
                            <mat-option *ngFor="let option of peoples" [value]="option.fullName" (click)="addpeopleMdmidFilterValue(option.mdmid)">
                                <div *ngIf="personFound"  >
                                    <span mat-raised-button 
                                    aria-label="Button that displays a tooltip in various positions">
                                    {{option.fullName}} </span> <br><small style="color: #E65400">{{option.email}}</small>
                                </div>
                                <div *ngIf="personNotFound">
                                    {{'Contract.noFound'| translate}}
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                        <div *ngIf="personDelegateForm.controls['mdmid'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                          <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>&nbsp; {{'SaaDelegatePortal.requiredField'|translate}}</mat-error></h5></span>
                        </div>
                      </div>
                     
                    </div>
                    <div class="col-md-4 u-pt20">
                        <div class="form-group" >
                            <label class="o-title o-title--required o-title--label ">{{'SaaDelegatePortal.from'|translate}}</label>
                            <mat-form-field style="width: 100%;" appearance="standard">
                            
                            <input matInput [min]="todayDate" [max]="maxDate" onkeydown="return false"   [matDatepicker]="picker" formControlName="fromDate" value="date" (dateChange)="cleaninputDatePost()">
                            <mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker  #picker></mat-datepicker>
                            </mat-form-field>  
                            <div *ngIf="personDelegateForm.controls['fromDate'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>&nbsp;{{'SaaDelegatePortal.requiredField'|translate}}</mat-error></h5></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 u-pt20">
                        <div class="form-group" *ngIf="personDelegateForm.controls['dateIndefinite'].value==false">
                            <label class="o-title o-title--required o-title--label ">{{'SaaDelegatePortal.to'|translate}}</label>
                            <mat-form-field style="width: 100%;" appearance="standard">
                              <input  matInput onkeydown="return false" [min]="personDelegateForm.controls.fromDate.value" [max]="maxDate"  [matDatepicker]="picker2" formControlName="toDate" value="date"  >
                              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                              <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>  
                            
                            <div *ngIf="personDelegateForm.controls['toDate'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                              <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>&nbsp;{{'SaaDelegatePortal.requiredField'|translate}}</mat-error></h5></span>
                            </div>
                          </div>
                          <div class="form-group"  >
                            <label class="o-title o-title--required o-title--label " *ngIf="personDelegateForm.controls['dateIndefinite'].value==true">{{'SaaDelegatePortal.to'|translate}}</label>
                            <div class="o-form__checkbox " style="margin-top: 11px;">
                                <input type="checkbox" value="value" (change)="changeLimitDatePost()" formControlName="dateIndefinite" name="ConfirmDate" ><span></span>
                                <p class="open_modal"  >{{'SaaDelegatePortal.dateUndefined'|translate}}</p>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="col-md-12 ">
                    <p>
                        <span class="table__mobile"> </span>
                        <button class="btn btn--primary open_modal" (click)="submitNewDelegate()" mat-raised-button [disabled]="personDelegateForm.invalid ? true: null">
                            <!-- <svg class="bi bi-plus" width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z" clip-rule="evenodd"></path>
                            <path fill-rule="evenodd" d="M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z" clip-rule="evenodd"></path>
                            </svg> -->
                            {{'SaaDelegatePortal.DelegateButton'|translate}}
                        </button>
                    </p>
                </div>
            </div>
        </section>

        <div class="u-pt20">
            <label class="o-title orange o-title--small o-title--semi u-mb10 ">{{'SaaDelegatePortal.ongoingDelegations'|translate}}</label>
           
            <section class="c-results">
              
              <div class="container " style="padding: 20px; margin-right: 20px; width:100%"> 
                <label class="o-title o-title--small o-title--semi u-mb10 ">{{'SaaDelegatePortal.filters'|translate}}</label>
                <div class="col-md-4 u-pt20">
                  <div class="form-group">
                    <label class="o-title o-title--label o-title--required js-txt16"  id="FirstName">{{'SaaDelegatePortal.personSearchFilter'|translate}}:</label>
                    <input  class="o-form__input" (input)="searchPersonFilter($event)" style="background-color: white;" [(ngModel)]="searchPeopleNameFilter"   type="text" placeholder="{{'SaaDelegatePortal.placeholderPersonSearchfilter'|translate}}" [matAutocomplete]="autoPersonBHP2">
                    <mat-autocomplete #autoPersonBHP2="matAutocomplete">
                        <mat-option *ngFor="let option of peoplesFilterSeach" [value]="option.fullName" (click)="peopleMdmidFilterUrlSetValue(option.mdmid)">
                            <div *ngIf="personFoundFilter"  >
                                <span mat-raised-button 
                                aria-label="Button that displays a tooltip in various positions">
                                {{option.fullName}} </span> <br><small style="color: #E65400">{{option.email}}</small>
                            </div>
                            <div *ngIf="personNotFoundFilter">
                                {{'Contract.noFound'| translate}}
                            </div>
                        </mat-option>
                    </mat-autocomplete>
                    <div *ngIf="personDelegateForm.controls['mdmid'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                      <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>&nbsp; {{'SaaDelegatePortal.requiredField'|translate}}</mat-error></h5></span>
                    </div>
                  </div>
                 
                </div>


                <div class="col-md-3 ">
                  <div class="form-group">
                    <label class="o-title o-title--label o-title--required js-txt16"  id="FirstName">{{'SaaDelegatePortal.fromDateFilterName'|translate}}:</label>
                  
                    <div slign="center">
                      <mat-form-field color="accent">
                          <mat-label>{{'SaaDelegatePortal.filterDateStartFrom'| translate}}</mat-label>
                          <input matInput   onkeydown="return false" #resultPickerModel="ngModel" [max]="maxDate" [matDatepicker]="picker3" (change)="datePeriodStartFinalF=undefined" [(ngModel)]="datePeriodStartStartF" value="date">
                          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                          <mat-datepicker #picker3></mat-datepicker>
                          <mat-error *ngIf="resultPickerModel.hasError('matDatepickerParse')">
                              "{{resultPickerModel.getError('matDatepickerParse').text}}" {{'SaaDelegatePortal.validDate'| translate}}
                          </mat-error>
                          <mat-error *ngIf="resultPickerModel.hasError('matDatepickerMax')">{{'SaaDelegatePortal.minDate'| translate}}</mat-error>
                      </mat-form-field>
                      <div slign="center">
                          <mat-form-field color="accent">
                              <mat-label>{{'SaaDelegatePortal.filterDateEndFrom'| translate}}</mat-label>
                              <input matInput  onkeydown="return false" #resultPickerModel2="ngModel" [min]="datePeriodStartStartF" [max]="maxDate" [matDatepicker]="picker4" [(ngModel)]="datePeriodStartFinalF" value="date">
                              <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                              <mat-datepicker #picker4></mat-datepicker>
                              <mat-error *ngIf="resultPickerModel2.hasError('matDatepickerParse')">
                                  "{{resultPickerModel2.getError('matDatepickerParse').text}}" {{'SaaDelegatePortal.validDate'| translate}}
                              </mat-error>
                          </mat-form-field>
                      </div>
                  </div>
                  
                  </div>


                </div>
                <div class="col-md-4 ">
                  <div class="form-group">
                    <label class="o-title o-title--label o-title--required js-txt16"  id="FirstName">{{'SaaDelegatePortal.toDateFilterName'|translate}}:</label>
                    <div slign="center">
                      <mat-form-field color="accent">
                          <mat-label>{{'SaaDelegatePortal.filterDateStartTo'| translate}}</mat-label>
                          <input matInput  onkeydown="return false" #resultPickerModel="ngModel" [max]="maxDate" [matDatepicker]="picker5" (change)="datePeriodEndFinalF=undefined" [(ngModel)]="datePeriodEndStartF" value="date">
                          <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                          <mat-datepicker #picker5></mat-datepicker>
                          <mat-error *ngIf="resultPickerModel.hasError('matDatepickerParse')">
                              "{{resultPickerModel.getError('matDatepickerParse').text}}" {{'SaaDelegatePortal.validDate'| translate}}
                          </mat-error>
                          <mat-error *ngIf="resultPickerModel.hasError('matDatepickerMax')">{{'SaaDelegatePortal.minDate'| translate}}</mat-error>
                      </mat-form-field>
                      <div slign="center">
                          <mat-form-field color="accent">
                              <mat-label>{{'SaaDelegatePortal.filterDateEndTo'| translate}}</mat-label>
                              <input matInput  onkeydown="return false" #resultPickerModel2="ngModel" [min]="datePeriodEndStartF" [max]="maxDate" [matDatepicker]="picker6" [(ngModel)]="datePeriodEndFinalF" value="date">
                              <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                              <mat-datepicker #picker6></mat-datepicker>
                              <mat-error *ngIf="resultPickerModel2.hasError('matDatepickerParse')">
                                  "{{resultPickerModel2.getError('matDatepickerParse').text}}" {{'SaaDelegatePortal.validDate'| translate}}
                              </mat-error>
                          </mat-form-field>
                      </div>
                  </div>

                </div>
                





                
              </div>

              <div class="col-md-12">

                <div class="c-search">
                    <tr>
                        <td>
                            <p style="padding: 10px;">
                                <span class="table__mobile"> </span>
                                <button class="btn btn--primary open_modal" (click)="clearFilter()" mat-raised-button>{{'SaaDelegatePortal.btnClearFilter'| translate}}</button>
                            </p>
                        </td>
                        <td>
                            <p>
                                <span class="table__mobile"> </span>
                                <button class="btn btn--primary open_modal" (click)="getalldelegateFilter()" mat-raised-button>{{'SaaDelegatePortal.btnApplyFilter'| translate}}</button>
                            </p>
                        </td>
                    </tr>
                </div>
              </div>
              </div>
            </section>


            <div class="o-etable">
                <div class="o-etable__employee">
                  <div class="row">
                    
                    <div class="col-md-2 col-xs-10">
                        <p class="u-hide__desktop"><strong >{{'SaaDelegatePortal.name'|translate}}</strong></p>
                      </div>
                      <div class="col-md-2 col-xs-10">
                        <p class="u-hide__desktop"><strong >{{'SaaDelegatePortal.email'|translate}}</strong></p>
                      </div>
                    <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                      <p class="u-hide__desktop"><strong >{{'SaaDelegatePortal.rutPassport'|translate}}</strong></p>
                    </div>

                    <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2" >
                        <p class="u-hide__desktop" ><strong>{{'SaaDelegatePortal.fromDate'|translate}}</strong>
                        </p>
                        <p class="u-hide__desktop"  (click)="orderby('periodFrom',DateFromDesc )"> <i *ngIf="!DateFromDesc"  class="icon icon-arrow icon-arrow-down orderColor"></i> 
                          <i *ngIf="DateFromDesc" style="transform: rotate(90deg);" class="icon icon-arrow orderColor "></i>  </p>
                    </div>
                    <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2" >
                        <p class="u-hide__desktop"   ><strong>{{'SaaDelegatePortal.toDate'|translate}}</strong>
                         
                        </p>
                        <p class="u-hide__desktop"  (click)="orderby('periodTo',DateToDesc )"> <i *ngIf="!DateToDesc"  class="icon icon-arrow icon-arrow-down orderColor"></i> 
                          <i *ngIf="DateToDesc" style="transform: rotate(90deg);" class="icon icon-arrow orderColor "></i> </p>
                    </div>
                      
                    <div class="col-md-4 col-xs-10 col-md-offset-0 col-xs-offset-2">
                      <p class="u-hide__desktop"><strong> {{'SaaDelegatePortal.actions'|translate}}</strong></p>
                    </div>
                  </div>
                </div>
              

                
                <div class="o-etable--body" >
                  <div class="o-etable__employee " *ngFor=" let person of delegatedList" >
                    <div class="row" >
                      <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                            <p>  {{person.fullname}}</p>
                      </div>
                      <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        <p class="emailLarge" title="{{person.email}}"> {{person.email}}</p>
                      </div>
                      <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                        
                        <p><span *ngIf="person.nationalId">{{person.nationalId}}</span><span *ngIf="person.passport && person.nationalId"> / </span> <span *ngIf="person.passport">{{person.passport}}</span></p>
                      </div>
                
                      <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2 textLeft" >
                        <p>{{person.detailDelegate.periodFrom| date: 'dd/MM/yyyy'  }} </p>

                      </div>
                      <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2 textLeft" >
                        <p *ngIf="!person.detailDelegate.isUndefined">{{person.detailDelegate.periodTo| date: 'dd/MM/yyyy'  }} </p>
                        <p *ngIf="person.detailDelegate.isUndefined">{{'SaaDelegatePortal.dateUndefined'|translate}}</p>
                      </div>
                      <div class="col-md-4 col-xs-10 col-md-offset-0 col-xs-offset-2">
                      <div *ngIf="person.detailDelegate.id==personEditDelegateForm.controls.Id.value">
                        <form [formGroup]="personEditDelegateForm">
                          <div class="form-group" >
                              <label class="o-title o-title--required o-title--label ">{{'SaaDelegatePortal.from'|translate}}</label>
                              <mat-form-field style="width: 100%;" appearance="standard">
                              
                              <input matInput [min]="todayDate" [max]="maxDate" onkeydown="return false"   [matDatepicker]="picker" formControlName="PeriodFrom" value="date" (dateChange)="cleaninputDateUpdate()">
                              <mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker  #picker></mat-datepicker>
                              </mat-form-field>  
                              <div *ngIf="personEditDelegateForm.controls['PeriodFrom'].hasError('required') && submitedEdit" style="width:100%; background-color: #F2F0E9" align="center">
                              <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>&nbsp;{{'SaaDelegatePortal.requiredField'|translate}}</mat-error></h5></span>
                              </div>
                          </div>
                     
                          <div class="form-group" *ngIf="personEditDelegateForm.controls['IsUndefined'].value==false">
                              <label class="o-title o-title--required o-title--label ">{{'SaaDelegatePortal.to'|translate}}</label>
                              <mat-form-field style="width: 100%;" appearance="standard">
                                <input  matInput onkeydown="return false" [min]="personEditDelegateForm.controls.PeriodFrom.value" [max]="maxDate"  [matDatepicker]="picker2" formControlName="PeriodTo" value="date"  >
                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                              </mat-form-field>  
                              
                              <div *ngIf="personEditDelegateForm.controls['PeriodTo'].hasError('required') && submitedEdit" style="width:100%; background-color: #F2F0E9" align="center">
                                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>&nbsp;{{'SaaDelegatePortal.requiredField'|translate}}</mat-error></h5></span>
                              </div>
                            </div>
                            <div class="form-group"  >
                              <label class="o-title o-title--required o-title--label " *ngIf="personEditDelegateForm.controls['IsUndefined'].value==true">{{'SaaDelegatePortal.to'|translate}}</label>
                              <div class="o-form__checkbox " style="margin-top: 11px;">
                                  <input type="checkbox" value="value" (change)="changeLimitDateUpdate()" formControlName="IsUndefined" name="ConfirmDate" ><span></span>
                                  <p class="open_modal"  >{{'SaaDelegatePortal.dateUndefined'|translate}}</p>
                              </div>
                          </div>
                          <div >
                            <p>
                                <span class="table__mobile"> </span>
                                <button class="btn btn--primary open_modal" (click)="confirmEdit()" mat-raised-button [disabled]="personEditDelegateForm.invalid ? true: null">
                                    <!-- <svg class="bi bi-plus" width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z" clip-rule="evenodd"></path>
                                    <path fill-rule="evenodd" d="M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z" clip-rule="evenodd"></path>
                                    </svg> -->
                                    {{'SaaDelegatePortal.SaveEdit'|translate}}
                                </button>
                               
                            </p>
                            <p>
                              <button class="btn btn--black open_modal" (click)="cancelEdit()" mat-raised-button >
                                <!-- <svg class="bi bi-plus" width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z" clip-rule="evenodd"></path>
                                <path fill-rule="evenodd" d="M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z" clip-rule="evenodd"></path>
                                </svg> -->
                                {{'SaaDelegatePortal.cancel'|translate}}
                            </button>
                            </p>
                        </div>
                        </form>
                        </div>
                      
                        <p *ngIf="person.detailDelegate.id!=personEditDelegateForm.controls.Id.value">
                          <svg class="bi bi-pencil" width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.293 3.293a1 1 0 011.414 0l2 2a1 1 0 010 1.414l-9 9a1 1 0 01-.39.242l-3 1a1 1 0 01-1.266-1.265l1-3a1 1 0 01.242-.391l9-9zM14 4l2 2-9 9-3 1 1-3 9-9z" clip-rule="evenodd"></path>
                            <path fill-rule="evenodd" d="M14.146 8.354l-2.5-2.5.708-.708 2.5 2.5-.708.708zM5 12v.5a.5.5 0 00.5.5H6v.5a.5.5 0 00.5.5H7v.5a.5.5 0 00.5.5H8v-1.5a.5.5 0 00-.5-.5H7v-.5a.5.5 0 00-.5-.5H5z" clip-rule="evenodd"></path>
                          </svg>  &nbsp; <a class="open_modal" (click)="EditDelegate(person)"  style="cursor:pointer"> {{'SaaDelegatePortal.actionEdit'|translate}}</a>&nbsp;&nbsp;&nbsp;
                          

                          <svg class="bi bi-trash-fill" width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M15 6H5v8.5c0 .634.164 1.23.456 1.685.288.448.747.815 1.33.815h6.428c.583 0 1.042-.367 1.33-.815.292-.454.456-1.051.456-1.685V6zM8 7.5a.5.5 0 00-1 0v7a.5.5 0 001 0v-7zm2-.5a.5.5 0 01.5.5v7a.5.5 0 01-1 0v-7A.5.5 0 0110 7zm3 .5a.5.5 0 00-1 0v7a.5.5 0 001 0v-7z" clip-rule="evenodd"/>
                            <path d="M3.5 4a1 1 0 011-1h11a1 1 0 011 1v1a1 1 0 01-1 1h-11a1 1 0 01-1-1V4z"/>
                            <path d="M8 3a1 1 0 011-1h2a1 1 0 011 1v1H8V3z"/>
                            <path fill-rule="evenodd" d="M4.5 3a1 1 0 00-1 1v1a1 1 0 001 1H5v9a2 2 0 002 2h6a2 2 0 002-2V6h.5a1 1 0 001-1V4a1 1 0 00-1-1H12a1 1 0 00-1-1H9a1 1 0 00-1 1H4.5zm3 4a.5.5 0 01.5.5v7a.5.5 0 01-1 0v-7a.5.5 0 01.5-.5zM10 7a.5.5 0 01.5.5v7a.5.5 0 01-1 0v-7A.5.5 0 0110 7zm3 .5a.5.5 0 00-1 0v7a.5.5 0 001 0v-7z" clip-rule="evenodd"/>
                          </svg>&nbsp;<a class="open_modal" (click)="deleteDelegate(person.detailDelegate.id)"  style="cursor:pointer">{{'SaaDelegatePortal.actionDelete'|translate}}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="row pagination-main">
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-6">
                        <ul class="pagination">
                            <mat-paginator #paginator [length]="totalItems" [pageSize]="pageSize" (page)="handlePage($event)" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
                        </ul>
                    </div>
                </div>
            </div>



        </div>

    </div>
</div>